import { Play, ExternalLink } from "lucide-react";
import { SITE } from "../config/site";
import { SOCIAL_ICONS } from "./Footer";
import { SectionHeading, Reveal } from "./Reveal";

export function SocialSection() {
  return (
    <section data-testid="social-section" className="mx-auto max-w-7xl px-4 py-16 sm:px-6 sm:py-24">
      <SectionHeading
        eyebrow="Follow My Mobile Mechanic"
        title="Real Repairs. Real Videos."
        sub="Watch actual brake jobs, diagnostic walkthroughs and repair education from the same hands that will work on your car."
      />

      <Reveal className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {SOCIAL_ICONS.map(({ key, label, Icon }) => (
          <a
            key={key}
            href={SITE.socials[key]}
            target="_blank"
            rel="noopener noreferrer"
            data-testid={`social-link-${key}`}
            className="group flex items-center gap-4 border border-edge bg-slate2 p-5 transition-all duration-300 hover:-translate-y-1 hover:border-crimson/60"
          >
            <span className="flex h-12 w-12 items-center justify-center bg-elevated text-slate-200 transition-colors group-hover:bg-crimson group-hover:text-white">
              <Icon className="h-6 w-6" />
            </span>
            <span>
              <span className="block font-display text-xl font-bold uppercase text-slate-50">{label}</span>
              <span className="flex items-center gap-1 text-xs text-slate-400">
                Follow along <ExternalLink className="h-3 w-3" />
              </span>
            </span>
          </a>
        ))}
      </Reveal>

      <div className="mt-10 grid gap-5 md:grid-cols-3">
        {SITE.featuredVideos.map((v, i) => (
          <Reveal key={v.title} delay={i * 0.1}>
            <a
              href={v.url}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`featured-video-${i}`}
              className="group block border border-edge bg-slate2 transition-all duration-300 hover:-translate-y-1 hover:border-amber2/60"
            >
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={v.thumb}
                  alt={v.alt}
                  loading="lazy"
                  className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-obsidian/90 to-transparent" />
                <span className="absolute left-4 top-4 bg-crimson px-2.5 py-1 font-mono text-[10px] font-bold uppercase tracking-widest text-white">
                  {v.platform}
                </span>
                <span className="absolute bottom-4 left-4 flex h-12 w-12 items-center justify-center rounded-full bg-amber2 text-obsidian transition-transform duration-300 group-hover:scale-110">
                  <Play className="h-5 w-5 fill-current" />
                </span>
              </div>
              <p className="p-4 font-display text-lg font-bold uppercase leading-tight text-slate-100">
                {v.title}
              </p>
            </a>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
